import { Button, Header, Modal } from '@bbl-digital/snorre'
import { CustomGrid } from 'shared/styles/common'

type Props = {
  onClose: () => void
  onDecision: (decision: 'yes' | 'no') => void
}

const TransformToBccModal = ({ onClose, onDecision }: Props) => (
  <Modal
    open
    onClose={onClose}
    header={<Header level={4}>Legg som blindkopi?</Header>}
    actionButton={
      <CustomGrid cols="1fr 1fr" bp="350px">
        <Button outline type="submit" onClick={() => onDecision('no')}>
          Nei
        </Button>
        <Button type="submit" onClick={() => onDecision('yes')}>
          Ja
        </Button>
      </CustomGrid>
    }
  >
    Du har valgt mange mottakere, ønsker du å benytte blindkopi?
  </Modal>
)

export default TransformToBccModal
